var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useCallback } from "react";
import { ProgressBar } from "@animech/ui";
import * as Styled from "./home-menu.style";
import { Welcome, Wizard, ApplicationSelectTab } from "./tabs";
import { Logo } from "ui/components/elements/logo";
import { PageRoute } from "utility/url";
import { useBlockingElementEffect } from "hooks/playcanvas/blocking-element-effect";
import { DeveloperTicket } from "ui/components/elements/ticket/developer-ticket";
import { SavedSystemsTab } from "ui/components/panels/home-menu/tabs/saved-systems/saved-systems";
import { PredefinedSystemsTab } from "ui/components/panels/home-menu/tabs/predefined-systems/predefined-systems-tab";
import { SelectApplicationMode } from "hooks/select-application";
import { actions, selectors, useAppDispatch, useAppSelector } from "store";
import { LanguagePicker } from "ui/components/panels/topbar/language-picker";
var tabs = [
    {
        activeOnRoutes: [PageRoute.WELCOME_SCREEN],
        navigateTo: PageRoute.WELCOME_SCREEN,
        titleKey: "home-menu.tabs.welcome",
    },
    {
        activeOnRoutes: [PageRoute.BLANK_SYSTEM],
        navigateTo: PageRoute.BLANK_SYSTEM,
        titleKey: "home-menu.tabs.blank_system",
    },
    {
        activeOnRoutes: [PageRoute.SELECT_APPLICATION, PageRoute.DEFINE_PARAMETERS],
        navigateTo: PageRoute.SELECT_APPLICATION,
        titleKey: "home-menu.tabs.wizard",
    },
    {
        activeOnRoutes: [PageRoute.SAVED_SYSTEMS],
        navigateTo: PageRoute.SAVED_SYSTEMS,
        titleKey: "home-menu.tabs.saved_systems",
    },
    {
        activeOnRoutes: [PageRoute.PREDEFINED_SYSTEMS],
        navigateTo: PageRoute.PREDEFINED_SYSTEMS,
        titleKey: "home-menu.tabs.predefined-systems",
    },
];
export var HomeMenu = function () {
    var dispatch = useAppDispatch();
    var navigate = useNavigate();
    var currentRoute = useLocation().pathname;
    var t = useTranslation().t;
    var pendingParameters = useAppSelector(selectors.selectPendingParameters);
    var hasPendingParameters = pendingParameters && Object.keys(pendingParameters).length > 0;
    // avoid mouse interactions with the scene
    useBlockingElementEffect();
    var goToScene = useCallback(function () {
        navigate(PageRoute.SYSTEM_DESIGN);
    }, [navigate]);
    var clearActiveSystemAndGoToScene = useCallback(function () {
        dispatch(actions.setUserActiveSystem(undefined));
        navigate(PageRoute.SYSTEM_DESIGN);
    }, [dispatch, navigate]);
    var selectedTab = function () {
        switch (currentRoute) {
            case PageRoute.WELCOME_SCREEN:
                return _jsx(Welcome, {});
            case PageRoute.SELECT_APPLICATION:
            case PageRoute.DEFINE_PARAMETERS:
                return _jsx(Wizard, {});
            case PageRoute.BLANK_SYSTEM:
                return (_jsx(ApplicationSelectTab, { modeWithChanges: SelectApplicationMode.RESET_AFTER_ASKING, modeWithoutChanges: SelectApplicationMode.RESET_WITHOUT_ASKING, header: t("home-menu.blank-system.header"), subHeader: t("home-menu.blank-system.sub-header"), confirmationModalHeaderTranslationKey: "reset_modal.restart_title", confirmationModalMessageTranslationKey: "reset_modal.restart_message", afterConfirmed: clearActiveSystemAndGoToScene }));
            case PageRoute.SAVED_SYSTEMS:
                return _jsx(SavedSystemsTab, {});
            case PageRoute.PREDEFINED_SYSTEMS:
                return _jsx(PredefinedSystemsTab, {});
            default:
                return null;
        }
    };
    return (_jsxs(Styled.HomeMenu, { children: [_jsxs(Styled.Sidebar, { children: [_jsx(DeveloperTicket, {}), _jsx(Styled.Logo, { children: _jsx(Logo, {}) }), _jsx(Styled.Tabs, { children: tabs.map(function (tab, index) { return (_jsx(Styled.Tab, { active: tab.activeOnRoutes.includes(currentRoute), onClick: function () {
                                navigate(tab.navigateTo);
                            }, children: t(tab.titleKey) }, index)); }) }), _jsx(Styled.SidebarButtons, { children: _jsx(Styled.CloseButton, { onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    goToScene();
                                    return [2 /*return*/];
                                });
                            }); }, children: t("home-menu.close") }) })] }), _jsxs(Styled.ContentContainer, { children: [_jsx(Styled.LanguagePickerContainer, { children: _jsx(LanguagePicker, {}) }), hasPendingParameters ? _jsx(ProgressBar, {}) : selectedTab()] })] }));
};
